import React from "react";
import { Link } from "react-router-dom";

import salmonTatakiMenu from "../../assets/images/resource/seafood-salmon-tataki-menu.webp";
import salmonTartareiMenu from "../../assets/images/resource/seafood-salmon-tartare-menu.webp";
import seaBitesMenu from "../../assets/images/resource/seafood-sea-bites-menu.webp";
import tunaCuppuMenu from "../../assets/images/resource/tuna-cuppu-menu.webp";
import sashimiSaladMenu from "../../assets/images/resource/menu/seafood/sashimi-salad.webp";
import ebiFuraiMenu from "../../assets/images/resource/menu/seafood/ebi-furai.webp";
import gesoKaraageMenu from "../../assets/images/resource/menu/seafood/geso-karaage.webp";
import takoyakiMenu from "../../assets/images/resource/menu/seafood/takoyaki.webp";

import crispyCube from "../../assets/images/resource/crispy-cube.webp";
import spicyImage from "../../assets/images/resource/spicy.png";
function Meat() {
  return (
    <>
      <section className="menu-two">
        <div className="auto-container">
          <div className="title-box centered">
            <h2>Seafood</h2>
          </div>
          <div className="row clearfix">
            <div className="menu-col col-lg-6 col-md-12 col-sm-12">
              <div className="inner">
                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={salmonTatakiMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                            Salmon Tataki<span className="s-info">3 PCS.</span>
                          </Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$21.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Seasoned salmon, truffle paste, ikura, leek served with
                        homemade yuzu sauce
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={crispyCube} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                            Crispy Cube<span className="s-info">3 PCS.</span>
                          </Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$21.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Potato mille-feuille topped with spicy ground tuna,
                        scallion and homemade mushroom paste
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={salmonTartareiMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Salmon Tartare</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$20.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Mango puréed, avocado, chive served with crackers
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={seaBitesMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                            Sea Bites<span className="s-info">3 PCS.</span>
                            <span className="s-info">CONTAIN PINE NUTS</span>
                          </Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$24.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Uni, scallop, ikura, crispy seaweed served with pesto
                        sauce
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={tunaCuppuMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                            Tuna cuppu<span className="s-info">3 PCS.</span>
                          </Link>
                          &nbsp;
                          <img
                            src={spicyImage}
                            alt="Icon"
                            width={30}
                            height={30}
                          ></img>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$24.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Yellowfin tuna, Cherry radish, Apple, Homemade chili
                        mayo served in lettuce cup
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="menu-col col-lg-6 col-md-12 col-sm-12">
              <div className="inner">
                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={sashimiSaladMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Sashimi Salad</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$20.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Chef's assorted sashimi with yuzu wasabi dressing &
                        bonito flake
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={ebiFuraiMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Ebi Furai</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$16.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Crispy shrimp mixed with homemade sweet & spicy mayo
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={gesoKaraageMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Geso Karaage</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$14.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Crispy squid legs served with homemade spicy mayo
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={takoyakiMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                            Takoyaki<span className="s-info">6 PCS.</span>
                          </Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$14.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Traditional Japanese crispy octopus ball with bonito
                        flake, red ginger, mayo & nori
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Meat;
